import { render, staticRenderFns } from "./comments-tab.vue?vue&type=template&id=3e1d1864"
import script from "./comments-tab.vue?vue&type=script&lang=js"
export * from "./comments-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports